'use client'

import { Suspense, useEffect } from 'react'

import { usePathname, useSearchParams } from 'next/navigation'

import { getTenantCurrent } from '@/lib/analytics'

function AnalyticsTrackerContent() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    const url =
      pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '')

    if (window.gtag) {
      const tenant = getTenantCurrent()

      window.gtag('event', 'page_view', {
        page_path: url,
        tenant: tenant,
      })
    }
  }, [pathname, searchParams])

  return null
}

export function AnalyticsTracker() {
  return (
    <Suspense fallback={null}>
      <AnalyticsTrackerContent />
    </Suspense>
  )
}
